namespace TabAurous.Common {
    export interface ItemBOM {
        RefTransBomId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        BOMProductId?: number;
        BOMAttributeId?: number;
        Lab?: string;
        CertificateNo?: string;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        SettingId?: number;
        BomRate?: number;
        BomAmount?: number;
        CCBomAmount?: number;
        Remarks?: string;
        Purity?: number;
        PureWeight?: number;
        HSN?: string;
        ProductTypeCode?: string;
        ItemTypeId?: number;
        ItemType?: string;
        CategoryId?: number;
        CategoryCode?: string;
        SubCategoryId?: number;
        SubCategoryCode?: string;
        KaratId?: number;
        KaratCode?: string;
        MetalColorId?: number;
        MetalColorCode?: string;
        ProductSizeId?: number;
        ProductSizeCode?: string;
        StoneSizeId?: number;
        StoneSizeCode?: string;
        BrandId?: number;
        BrandCode?: string;
        CollectionId?: number;
        CollectionCode?: string;
        SuperTypeId?: number;
        SuperTypeCode?: string;
        ShapeId?: number;
        ShapeCode?: string;
        SieveId?: number;
        SieveCode?: string;
        GroupSieveId?: number;
        GroupSieveCode?: string;
        QualityId?: number;
        QualityCode?: string;
        StoneColorId?: number;
        StoneColorCode?: string;
        StampId?: number;
        StampCode?: string;
        MetalId?: number;
        MetalCode?: string;
        StoneCutId?: number;
        StoneCutCode?: string;
        StonePolishId?: number;
        StonePolishCode?: string;
        StoneSymmetryId?: number;
        StoneSymmetryCode?: string;
        StoneFluorescenceId?: number;
        StoneFluorescenceCode?: string;
        StoneCuletId?: number;
        StoneCuletCode?: string;
        StoneGirdleId?: number;
        StoneGirdleCode?: string;
        StoneTable?: string;
        StoneDepth?: string;
    }
}
